import { render, staticRenderFns } from "./TmpOrderHeader.vue?vue&type=template&id=54c07eec&scoped=true&lang=pug"
import script from "./TmpOrderHeader.vue?vue&type=script&lang=js"
export * from "./TmpOrderHeader.vue?vue&type=script&lang=js"
import style0 from "./TmpOrderHeader.vue?vue&type=style&index=0&id=54c07eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c07eec",
  null
  
)

export default component.exports